"use strict";
import SocialAppDispatcher from "../dispatcher/SocialAppDispatcher";
import SocialConstants from "../constants/SocialConstants";
import filter from "lodash/filter";
import find from "lodash/find";
var ActionTypes = SocialConstants.ActionTypes;
var actions = {
    /**
   * DISCLAIMER
   */ receiveEndorsement: function receiveEndorsement(rawEndorsementStatus) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ENDORSEMENT,
            rawEndorsementStatus: rawEndorsementStatus
        });
    },
    /**
   * CONNECTION
   */ serverConnectionUpdate: function serverConnectionUpdate(endPoint, status, reason) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.CONNECTION_UPDATE,
            endPoint: endPoint,
            status: status,
            reason: reason || ""
        });
    },
    /**
   * SESSION
   */ receiveConfig: function receiveConfig(rawConfig) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CONFIG,
            rawConfig: rawConfig
        });
    },
    receiveSession: function receiveSession(rawSession) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SESSION,
            rawSession: rawSession
        });
    },
    /**
   * SPHERES
   */ receiveSpheres: function receiveSpheres(rawSpheres) {
        var sp = filter(rawSpheres, {
            note: false
        });
        var noteSp = find(rawSpheres, {
            note: true
        });
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_SPHERES,
            rawSpheres: sp,
            rawNoteSphere: noteSp
        });
    },
    receiveSphere: function receiveSphere(rawSphere) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_SPHERE,
            rawSphere: rawSphere
        });
    },
    /**
   * TOPICS
   */ receiveTopics: function receiveTopics(rawTopics) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_TOPICS,
            rawTopics: rawTopics
        });
    },
    receiveTopic: function receiveTopic(rawTopic) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_TOPIC,
            rawTopic: rawTopic
        });
    },
    receiveTopicDescription: function receiveTopicDescription(rawTopic) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_DESCRIPTION,
            rawTopic: rawTopic
        });
    },
    /**
   * Notes
   */ receiveNotes: function receiveNotes(rawNotes) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_NOTES,
            rawNotes: rawNotes
        });
    },
    receiveNote: function receiveNote(rawNote) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_NOTE,
            rawNote: rawNote
        });
    },
    receivePrintNotes: function receivePrintNotes(rawNotes) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_PRINT_NOTES,
            rawNotes: rawNotes
        });
    },
    /**
   * ACTIVITIES
   */ receiveActivities: function receiveActivities(rawActivities) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_ACTIVITIES,
            rawActivities: rawActivities
        });
    },
    receiveActivity: function receiveActivity(rawActivity, topic) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_ACTIVITY,
            rawActivity: rawActivity,
            topic: topic
        });
    },
    receiveFileUploadComplete: function receiveFileUploadComplete(file, target, type) {
        SocialAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_RAW_FILE_UPLOAD_COMPLETE,
            result: {
                file: file,
                target: target,
                type: type
            }
        });
    }
};
export var key = actions.key;
export default actions;
